export class ErrorCodeManagementToken {
  static IErrorCodeManagementRepository = Symbol(
    "IErrorCodeManagementRepository",
  );
  static ErrorCodeManagementUseCase = Symbol("ErrorCodeManagementUseCase");
  static ErrorCodeManagementViewModel = Symbol("ErrorCodeManagementViewModel");
}
